import React, { FC } from 'react';
import Form from 'components/Form';

import { CalgonPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Calgon: FC<CalgonPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Calgon;
